module.exports = __webpack_public_path__ + "img/genesis_flame_test_version_update_announcement.a8474d87.png";